module.exports = __webpack_public_path__ + "media/KZ-KAR.47e6bcd9.ogg";